import { takeEvery, takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { fetchModuleAccessSaga, fetchCompanyModuleAccessSaga, updateModuleAccessSaga } from './moduleAccessSaga';

export function* moduleAccessSaga() {
  yield takeLatest(sagaActions.GET_MODULE_ACCESS, fetchModuleAccessSaga);
  yield takeLatest(sagaActions.GET_COMPANY_MODULE_ACCESS, fetchCompanyModuleAccessSaga);
  yield takeEvery(sagaActions.UPDATE_MODULE_ACCESS, updateModuleAccessSaga);
}
